// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-selector button {
    padding: 6px 14px;
    border-radius: var(--radius-sm);
    background-color: var(--primary);
    color: white;
    font-weight: 600;
    font-size: 13px;
    transition: all var(--transition-fast);
}

.date-selector button:hover {
    background-color: var(--primary-hover);
}

.date-picker-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.date_compared_text {
    margin: 0;
    font-size: 13px;
    color: var(--text-secondary);
}

.react-datepicker__month-container {
    background-color: var(--bg-card);
    padding: 10px;
    border-radius: 0 0 var(--radius-sm) var(--radius-sm);
}

.react-datepicker__header {
    background-color: var(--bg-card) !important;
}

.react-datepicker__navigation--previous {
    left: 7px !important;
}

.react-datepicker__navigation--next {
    right: 7px !important;
}

.react-datepicker__navigation--next-with-time {
    right: 107px !important;
}

.react-datepicker__navigation {
    top: 7px !important;
}

.header_selectDate {
    display: flex;
    gap: 10px;
    justify-content: center;
    max-width: 100%;
    padding: 10px 0;
}

.react-datepicker__input-time-container {
    display: flex;
    background-color: var(--bg-card);
    justify-content: center;
    height: 4rem;
    padding: 0;
    margin-top: 0px;
    margin-left: 0px;
    clear: both;
    width: 100%;
    float: left;
}

.react-datepicker-time__input {
    margin: 0;
    height: 2rem;
    font-size: 1.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Filters/DateSelector/DateSelector.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".date-selector button {\n    padding: 6px 14px;\n    border-radius: var(--radius-sm);\n    background-color: var(--primary);\n    color: white;\n    font-weight: 600;\n    font-size: 13px;\n    transition: all var(--transition-fast);\n}\n\n.date-selector button:hover {\n    background-color: var(--primary-hover);\n}\n\n.date-picker-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.date_compared_text {\n    margin: 0;\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.react-datepicker__month-container {\n    background-color: var(--bg-card);\n    padding: 10px;\n    border-radius: 0 0 var(--radius-sm) var(--radius-sm);\n}\n\n.react-datepicker__header {\n    background-color: var(--bg-card) !important;\n}\n\n.react-datepicker__navigation--previous {\n    left: 7px !important;\n}\n\n.react-datepicker__navigation--next {\n    right: 7px !important;\n}\n\n.react-datepicker__navigation--next-with-time {\n    right: 107px !important;\n}\n\n.react-datepicker__navigation {\n    top: 7px !important;\n}\n\n.header_selectDate {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    max-width: 100%;\n    padding: 10px 0;\n}\n\n.react-datepicker__input-time-container {\n    display: flex;\n    background-color: var(--bg-card);\n    justify-content: center;\n    height: 4rem;\n    padding: 0;\n    margin-top: 0px;\n    margin-left: 0px;\n    clear: both;\n    width: 100%;\n    float: left;\n}\n\n.react-datepicker-time__input {\n    margin: 0;\n    height: 2rem;\n    font-size: 1.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
